var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMui(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "208px",
    viewBox: "0 0 256 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6235294,35.0117647 L15.6235294,122.541176 L30.6823529,114.070588 L30.6823529,43.4823529 L15.6235294,35.0117647 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.564705882,114.070588 L0.564705882,8.65882353 L89.9764706,59.4823529 L89.9764706,77.3647059 L15.6235294,35.0117647 L15.6235294,122.541176 L0.564705882,114.070588 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.270588,8.65882353 L181.270588,114.070588 L121.035294,147.952941 L105.976471,138.541176 L166.211765,104.658824 L166.211765,34.0705882 L89.9764706,77.3647059 L89.9764706,59.4823529 L181.270588,8.65882353 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.211765,0.188235294 L90.9176471,42.5411765 L15.6235294,0.188235294 L0.564705882,8.65882353 L89.9764706,59.4823529 L181.270588,8.65882353 L166.211765,0.188235294 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.152941,42.5411765 L151.152941,96.1882353 L166.211765,104.658824 L166.211765,34.0705882 L151.152941,42.5411765 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8588235,138.541176 L151.152941,96.1882353 L166.211765,104.658824 L105.976471,138.541176 L165.270588,172.423529 L225.505882,138.541176 L240.564706,147.011765 L165.270588,189.364706 L75.8588235,138.541176 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8588235,138.541176 L75.8588235,156.423529 L165.270588,207.247059 L165.270588,189.364706 L75.8588235,138.541176 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.564706,147.011765 L240.564706,94.3058824 L225.505882,85.8352941 L225.505882,138.541176 L240.564706,147.011765 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.270588,189.364706 L240.564706,147.011765 L240.564706,94.3058824 L255.623529,85.8352941 L255.623529,156.423529 L165.270588,207.247059 L165.270588,189.364706 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.623529,85.8352941 L240.564706,94.3058824 L225.505882,85.8352941 L240.564706,77.3647059 L255.623529,85.8352941 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.564706,77.3647059 L240.564706,59.4823529 L255.623529,51.0117647 L255.623529,68.8941176 L240.564706,77.3647059 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.564706,59.4823529 L240.564706,77.3647059 L225.505882,68.8941176 L225.505882,51.0117647 L240.564706,59.4823529 Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.623529,51.0117647 L240.564706,59.4823529 L225.505882,51.0117647 L240.564706,42.5411765 L255.623529,51.0117647 Z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/mui.fe5f49292eb44c5312457065b62c870b.svg";
export { ForwardRef as ReactComponent };